import React from 'react';
import { useAppContext, UserAvatarProps } from '../../AppContext';
import { Image } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

interface DirectionProps {
  isRTL: boolean;
}

const UserAvatar = (props: UserAvatarProps) => {
    return (
        <StyledImage
            src={props.user.avatar || 'static/img/no-profile-picture.jpeg'}
            roundedCircle
        />
    );
}

const UserInfoComponent = ({ ...props }) => {
    const app = useAppContext();
    const user = app.user || { displayName: "", email: "" };
    const { i18n,t } = useTranslation();
    const isRTL = i18n.language === 'ar';

    return (
        <UserInfoWrapper dir="ltr" isRTL={isRTL}>
            <UserAvatar user={user} />
            <UserText isRTL={isRTL}>
                <UserEmail>{user.displayName}</UserEmail>
                <UserJobTitle>{user.jobTitle}</UserJobTitle>
            </UserText>
            <StyledButton isRTL={isRTL} onClick={app.signOut!} className="button-link">
            {t('logout')} 
            </StyledButton>
        </UserInfoWrapper>
    );
}

const UserInfoWrapper = styled.div<DirectionProps>`
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    ${({ isRTL }) => isRTL && css`
        flex-direction: row-reverse;
    `}
`;

const UserText = styled.div<DirectionProps>`
    display: flex;
    flex-direction: column;
    align-items: ${({ isRTL }) => (isRTL ? 'flex-end' : 'flex-start')};
    margin: ${({ isRTL }) => (isRTL ? '0 10px 0 0' : '0 0 0 10px')};
`;

const UserEmail = styled.div`
    font-size: 1rem;
    font-weight: bold;
    color: #333;
`;

const UserJobTitle = styled.div`
    font-size: 0.75rem;
    color: #888;
`;

const StyledImage = styled(Image)`
    width: 40px;
    height: 40px;
`;

const StyledButton = styled.button<DirectionProps>`
        background-color: var(--primary-color);
    border: none;
    color: var(--font-color);
    padding: 0 10px;
    font-size: 0.75rem;
    cursor: pointer;
    margin-left: auto;
    ${({ isRTL }) => isRTL && css`
        margin-left: 0;
        margin-right: auto;
    `}
`;

export default UserInfoComponent;
